import script from "./AddPackage.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPackage.vue?vue&type=script&setup=true&lang=js"

import "./AddPackage.vue?vue&type=style&index=0&id=475d8525&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-475d8525"]])

export default __exports__